import { BaseJs } from '@gate31/core/src/libs/BaseJsComponents';
import { ReviewsItems } from '@gate31/feature/ReviewsItems/ReviewsItems';

export class ProductReviewsItemsDesk extends ReviewsItems {
    static cn = new BaseJs.BuildCn('ProductReviewsItemDesk');

    className = ProductReviewsItemsDesk.cn.toString();
}
